import React from "react";
import TranslationServiceCards from "../translationServiceCards";
import { FinancialCardData2 } from "./config";

export default function EveryNeed({ backgroundCol }) {
  return (
    <div className={backgroundCol ? backgroundCol : "bg-darkBlue"}>
      <div className="mainDiv flex lg:flex-col flex-wrap mx-auto justify-center w-full lg:w-7/12 py-24 ">
        <div className="divTop  flex flex-col justify-center items-center relative">
          <h2 className="md:text-4xl text-2xl px-4 md:px-0 text-center font-secondary text-white font-extrabold">
            <span className="text-orange">Legal</span> Translation Services for Your Every Need
          </h2>

          <p className="text-center text-darkMist mt-12 mb-8 px-4 md:px-16 font-opensans  text-lg border-b-[0.5px] border-solid border-gray leading-8 font-light py-6">
            Tomedes services for attorneys, law firms, courts, and private individuals are diverse. They include certified legal translations of personal documents and certificates, contractual
            documents, intellectual property documents, regulatory and technical documentation for corporate and government clients.
          </p>
        </div>

        <div className="div flex flex-wrap mx-auto justify-center py-24 lg:px-0 px-4 gap-x-32">
          <div className="leftText text-white w-full  flex-col">
            <h3 className="md:text-3xl text-2xl font-secondary font-bold pb-6 text-center">
              Our
              <span className="text-orange"> Popular </span>
              Legal Document Translation Services
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 px-6 md:px-0 lg:pl-16 ">
              <ul className="list-disc font-opensans text-darkMist text-sm place-items-center">
                <li className="py-3">Contract translation</li>
                <li className="py-3">Summons translation</li>
                <li className="py-3">Patent and trademark filings translation</li>
                <li className="py-3">Deeds translation</li>
                <li className="py-3">Litigation document translation</li>
                <li className="py-3">Immigration document translation</li>
                <li className="py-3">
                  Witness statement / deposition <br /> translation
                </li>
                <li className="py-3">Legal certification translation</li>
                <li className="py-3">Legal disclaimers translation</li>
                <li className="py-3">Legal marketing translation</li>
                <li className="py-3">Will translation</li>
              </ul>
              <ul className="list-disc font-opensans text-darkMist text-sm">
                <li className="py-3">Articles of incorporation translation</li>
                <li className="py-3">Letters of credit translation</li>
                <li className="py-3">Affidavits translation</li>
                <li className="py-3">Arbitration translation</li>
                <li className="py-3">Confidentiality agreement translation</li>
                <li className="py-3">Correspondence translation</li>
                <li className="py-3">Foreign legal text translation</li>
                <li className="py-3">Government and legal ruling reports translation</li>
                <li className="py-3">License</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <TranslationServiceCards colheading="Services" heading="Related to Legal Translation" cardData={FinancialCardData2} backgroundCol="bg-midBlue" />
    </div>
  );
}
